import React from 'react';
import {
  Breadcrumbs as MUIBreadcrumbs,
  Link,
  Typography,
} from '@material-ui/core';
import { useLocation, useNavigate } from 'react-router-dom';

interface Props {
  location: any;
}

const Breadcrumbs = (props: Props) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const pathKeys = {
    usermanagement: 'User Management',
    userdetails: 'User Details',
    subscribeduserdetails: 'Subscribed User Details',
    channelmanagement: 'Channel Management',
    channeldetails: 'Channel Details',
    rolemanagement: 'Role Management',
    addRoles: 'Add New Roles',
    editRoles: 'Edit Roles',
    domesmanagement: 'Domes Management',
    addDomes: 'Add Domes',
    editDomes: 'Edit Domes',
    subdomesmanagement: 'Sub Domes Management',
    addSubDomes: 'Add Sub Domes',
    editSubDomes: 'Edit Sub Domes',
    subadminmanagement: 'SubAdmin Management',
    addSubAdmin: 'Add Sub Admin',
    editSubAdmin: 'Edit Sub Admin',
    reportusermanagement: 'Report User Management',
    subscribedusers: 'Subscribed User Management',
    reportuserinfo: 'User Report Info',
    contentmanagement: 'Content Management',
    editFAQs: 'Edit FAQ',
    addFAQS: 'Add FAQ',
    notification: 'Notification Management',
    addNotification: 'Add Notification',
    livestreaming: 'Event Management',
    livestreaminfo: 'Event Management Info',
    versionmanagement: 'Version Management',
    addVersion: 'Add Version',
    reportedpost: 'Reported Post',
    support: 'Support',
    supportinfo: 'Support Info',
    paymentmanagement: 'Payment Management',
    paymentinfo: 'Payment Info',
    editNotification: 'Edit Notification',
    sessionmanagement: 'Session Management',
    sessioninfo: 'Session Details',
    ecommerce: 'E-commerce Management',
    ecommerceInfo: 'E-commerce Info',
    entervice: 'ENTER VICE',
    addPreset: 'Add Preset',
    editPreset: 'Edit Preset',
    specialposts: 'Special Posts',
    addSpecialPost: 'Add Special Post Type',
    editSpecialPost: 'Edit Special Post Type',
  };

  const pathnames: any = [];
  console.log(pathnames, 'PATHNAMES')
  pathname.split('/').forEach((x: any) => {
    Object.keys(pathKeys).forEach((ele: any) => {
      if (ele === x) {
        pathnames.push({ key: pathKeys[ele as keyof typeof pathKeys], value: ele });
      }
    });
  });

  return (
    <MUIBreadcrumbs separator=">" aria-label="breadcrumb">
      {pathnames.length > 1 && pathnames.map((name: any, index: any) => {
        const routeTo = `/${name.value}`;
        const isLast = index === pathnames.length - 1;
        return isLast ? (
          <Typography key={name.key}>{name.key}</Typography>
        ) : (
          // eslint-disable-next-line jsx-a11y/anchor-is-valid
          <Link
            key={name}
            onClick={() => {
              if (routeTo === '/reportuserinfo') {
                navigate(-1);
              } else {
                navigate(routeTo);
              }
            }}
          >
            {name.key}
          </Link>
        );
      })}
    </MUIBreadcrumbs>
  );
};

export default Breadcrumbs;
